import tinycolor from 'tinycolor2';

export const convertColorToRgbString = (color: string) => {
  const rgb = tinycolor(color).toRgb(); // {r: 150, g: 120, b: 50}
  return `${rgb.r}, ${rgb.g}, ${rgb.b}`;
};
